export default {
  SET_MODELS: (state, data) => {
    state.models = data;
  },
  SET_MODEL: (state, data) => {
    state.model = data;
  },
};
